<template>
  <div class="main">
    <div class="body">
      <b-form-group label="ตั้งค่าขนาดเอกสาร" v-slot="{ ariaDescribedby }">
        <b-form-radio
          v-model="selected"
          :aria-describedby="ariaDescribedby"
          value="1"
        >
          รูปแบบเต็ม
        </b-form-radio>
        <b-form-radio
          v-model="selected"
          :aria-describedby="ariaDescribedby"
          value="2"
        >
          รูปแบบย่อ
        </b-form-radio>
      </b-form-group>
      <div class="footer">
        <b-button class="btn-cancel" @click="cancel">ย้อนกลับ</b-button>
        <b-button class="btn-save" @click="changeStatusPaper">บันทึก</b-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selected: "",
    };
  },
  mounted() {
    this.getStatusPaper();
  },
  methods: {
    changeStatusPaper() {
      let body = {
        pageSizeId: this.selected,
      };

      this.axios
        .post(`${this.$baseUrl}/Batch/SubmitSettingPaperSize`, body)
        .then((data) => {
          if (data.result == 1) {
            this.$emit("cancel");

            // modal import in main pages
            this.$bvModal.show("modal-text");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getStatusPaper() {
      this.axios
        .get(`${this.$baseUrl}/Batch/StatusPaperSize`)
        .then((data) => {
          if (data.result == 1) {
            this.selected = data.detail.id;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    cancel() {
      this.$emit("cancel");
    },
  },
};
</script>

<style scoped>
.main {
  position: relative;
  width: 100%;
}
.body {
  height: calc(100vh - 300px);
  overflow-y: auto;
}
.btn-cancel {
  background: white;
  min-width: 100px;
}
.btn-cancel:hover {
  color: grey !important;
}
.btn-save {
  background: #b41bb4;
  color: white !important;
  border: none;
  min-width: 100px;
}
.footer {
  position: absolute;
  bottom: 0;
  display: flex;
  justify-content: space-between;
  width: 100%;
}
</style>
